import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PersonaContext } from "../context/PersonaContext";
import Header from "../components/Header";
import StatusBar from "../components/StatusBar";
import LoadingSpinner from "../components/LoadingSpinner";
import ErrorMessage from "../components/ErrorMessage";
import { getEthnicities, retryApiCall } from "../services/api";

const EthnicityPage = () => {
  const {
    selectedDataset,
    selectedDatasetName,
    selectedDatasetPath,
    selectedEthnicities,
    setSelectedEthnicities,
  } = useContext(PersonaContext);
  const [ethnicities, setEthnicities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [validationError, setValidationError] = useState("");

  const fetchEthnicities = async () => {
    setLoading(true);
    setError("");
    try {
      const data = await retryApiCall(getEthnicities, [
        selectedDatasetName,
        selectedDatasetPath,
      ]);
      setEthnicities(data);
    } catch (error) {
      setError("Failed to load ethnicities");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEthnicities();
  }, [selectedDataset]);

  const handleEthnicitySelection = (ethnicityId) => {
    setSelectedEthnicities((prev) =>
      prev.includes(ethnicityId)
        ? prev.filter((id) => id !== ethnicityId)
        : [...prev, ethnicityId]
    );
    setValidationError("");
  };

  const handleSelectAll = () => {
    setSelectedEthnicities(ethnicities.map((ethnicity) => ethnicity));
    setValidationError("");
  };

  const handleUnselectAll = () => {
    setSelectedEthnicities([]);
    setValidationError("");
  };

  const handleNextClick = () => {
    if (selectedEthnicities.length === 0) {
      setValidationError("Please select at least one ethnicity");
      return;
    }
    navigate("/loading");
  };

  return (
    <div className="ethnicity-page">
      <Header />
      <StatusBar currentStep={4} />
      <h2>Select Ethnicity</h2>
      <p>Select ethnicities that are relevant to your persona creation.</p>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {error && (
            <div className="error-container">
              <ErrorMessage message={error} />
              <button onClick={fetchEthnicities} className="retry-button">
                Try Again
              </button>
            </div>
          )}
          {validationError && <ErrorMessage message={validationError} />}
          <div className="topic-buttons">
            <button onClick={handleSelectAll} className="link-button">
              Select All
            </button>
            <button onClick={handleUnselectAll} className="link-button">
              Unselect All
            </button>
          </div>
          <ul className="ethnicity-list">
            {ethnicities.map((ethnicity) => (
              <li key={ethnicity}>
                <input
                  type="checkbox"
                  id={`ethnicity-${ethnicity}`}
                  name="ethnicity"
                  value={ethnicity}
                  checked={selectedEthnicities.includes(ethnicity)}
                  onChange={() => handleEthnicitySelection(ethnicity)}
                />
                <label htmlFor={`ethnicity-${ethnicity}`}>{ethnicity}</label>
              </li>
            ))}
          </ul>
          <div className="navigation-buttons">
            <button
              onClick={() => navigate("/questions")}
              className="back-button"
            >
              Back
            </button>
            <div className="create-persona-container">
              <button
                onClick={handleNextClick}
                className="create-persona-button"
              >
                GENERATE PERSONAS!
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EthnicityPage;
